import React from 'react';

import { Box, VisuallyHidden } from '@zillow/constellation';

import { Shimmer } from '../Shimmer/Shimmer';

const SHIMMER_BORDER_RADIUS = 'calc( $radii.sm / 3 )';

export const JumpBackInCardSkeleton = () => (
    <React.Fragment>
        <VisuallyHidden>Loading</VisuallyHidden>
        <Box sx={{ width: '60px', height: '$spacing.xl' }}>
            <Shimmer borderRadius={SHIMMER_BORDER_RADIUS} />
        </Box>
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'space-between',
                gap: '$spacing.xs',
            }}
        >
            <Box sx={{ width: '220px', height: '$spacing.sm' }}>
                <Shimmer borderRadius={SHIMMER_BORDER_RADIUS} />
            </Box>
            <Box sx={{ width: '190px', height: '$spacing.sm' }}>
                <Shimmer borderRadius={SHIMMER_BORDER_RADIUS} />
            </Box>
            <Box sx={{ width: '190px', height: '$spacing.sm' }}>
                <Shimmer borderRadius={SHIMMER_BORDER_RADIUS} />
            </Box>
        </Box>
    </React.Fragment>
);
